import { PlannerBase } from '../../planner_base';
import watch   from "redux-watch";
import isEqual from 'is-equal';
import moment from 'moment';
import {
  LineSelectedCell
} from '../model';
import {
  PLANNER_SELECT_START_DATE,
  PLANNER_CLICK_BACK_SCHEDULE,
  PLANNER_CLICK_FORWARD_SCHEDULE
} from 'apps/events';
import { AddressSearchUtil } from 'utilities/address';
import PlannerControllerBase from './base';
export default class GlobalController extends PlannerControllerBase {
  constructor(tag){
    super(tag);
    this.customEvent(PLANNER_SELECT_START_DATE, (e) => { this.onSelectStartDate(e) });
    this.customEvent(PLANNER_CLICK_BACK_SCHEDULE, (e) => { this.onClickBackSchedule(e) });
    this.customEvent(PLANNER_CLICK_FORWARD_SCHEDULE, (e) => { this.onClickForwardSchedule(e) });
  }
  // 日付が選択された
  onSelectStartDate(e){
    let date = e.detail;
    let params = { start: date.format('YYYY-MM-DD') };
    App.location.visit({ search: params });
  }
  // これより前のスケジュールがありますボタンが押された
  onClickBackSchedule(e){
    let date = e.detail;
    date = date.subtract(1, 'week');
    let params = { start: date.format('YYYY-MM-DD') };
    App.location.visit({ search: params });
  }
  // これより後ろのスケジュールがありますボタンが押された
  onClickForwardSchedule(e){
    let date = e.detail;
    date = date.add(1, 'week').subtract(90, 'day');
    let params = { start: date.format('YYYY-MM-DD') };
    App.location.visit({ search: params });
  }
}
